import { render, staticRenderFns } from "./AgentRemittance.vue?vue&type=template&id=c620b30a&scoped=true&"
import script from "./AgentRemittance.vue?vue&type=script&lang=js&"
export * from "./AgentRemittance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c620b30a",
  null
  
)

export default component.exports